export default __webpack_public_path__ + "static/media/safe_secure.9083d703.svg";